import * as React from "react";
import Container from "@mui/material/Container";
import { Box, Typography, Grid } from "@mui/material";
import Frame from "../images/frame.svg";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import useStyles from "../css/fqaStyle.js";

export default function Home() {
    const classes = useStyles;  // Use the styles

    const [expanded, setExpanded] = React.useState("panel1"); // Set "panel1" as default expanded

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const getExpandIcon = (panel) => {
        return expanded === panel ? <RemoveIcon sx={{ color: '#0D8B5A' }} /> : <AddIcon sx={{ color: '#0D8B5A' }} />;
    };

    // Questions and answers array
    const faqData = [
        {
            question: "How can I pay?",
            answer: "You can pay using various methods, including credit cards, debit cards, and online payment services like PayPal or Stripe."
        },
        {
            question: "What is the refund policy?",
            answer: "All payments are non- refundable. Please review your purchase carefully before finalizing your transaction."
        },
        {
            question: "Can I cancel my subscription?",
            answer: "Yes, you can cancel your subscription at any time from your account settings. Cancellations take effect at the end of your billing cycle."
        },
        {
            question: "How to change password on AMBD platform?",
            answer: (
                <div>
                    <ol>
                        <li>Go to <a href="https://biz.ambd.info">https://biz.ambd.info</a></li>
                        <li>Enter username (provided via email, ensure we have the correct email address).</li>
                        <li>Click on "Forgot Password" (do not enter password).</li>
                        <li>Enter your business email address.</li>
                        <li>AMBD will send a 4-digit OTP to your email.</li>
                        <li>Enter the OTP and create a new password.</li>
                        <li>Click "Confirm" to successfully reset your password.</li>
                    </ol>
                    <p>The password will be changed successfully.</p>
                </div>
            )
        },
        {
            question: "Is my payment information secure?",
            answer: "Yes, we use industry-standard encryption to ensure that your payment information is secure and protected."
        },
        {
            question: "Can I upgrade my subscription plan?",
            answer: "Absolutely! You can upgrade your subscription plan anytime by visiting the 'Billing' section in your account."
        },
        {
            question: "Do you offer customer support?",
            answer: "You can reach out to us via email, phone or chat on WhatsUp no +61493740303"
        },
        {
            question: "Are there any discounts for annual subscriptions?",
            answer: "Yes, annual subscriptions are discounted by 20% compared to monthly plans."
        },
        {
            question: "How to Subscribe with AMBD?",
            answer: (
                <div>
                    
                    <p>Here are simple steps to follow to sign-up for Basic Subscription:</p>
                    <ol>
                        <li>Go to <a href="https://biz.ambd.info" target="_blank" rel="noopener noreferrer">https://biz.ambd.info</a></li>
                        <li>Enter username (provided to your business email).</li>
                        <li>Enter Password (your password or provided password for 1st time login).</li>
                        <li>Click "Subscription" from the left-hand side menu.</li>
                        <li>The subscription page opens up, then click "Compare Packages".</li>
                        <li>Click the "Subscription" button.</li>
                        <li>Choose your package depending on Monthly or Yearly subscription to suit your business needs.</li>
                        <li>Example: If you choose "Monthly Basic Subscription," click on the Monthly Package ($4.99/month).</li>
                        <li>Click the "Subscribe" button.</li>
                        <li>Enter your Card Details, Expiry Date, and CVC number.</li>
                        <li>Click the "Submit Payment" button.</li>
                        <li>You will get a pop-up saying "Payment made successfully".</li>
                    </ol>
                    <p>
                        After this, you can click on your Business on the Home Page to add more details for Basic Subscription, 
                        like all Social Media links, FAQs, and Images.
                    </p>
                </div>
            )
        },
        {
            question: "How to Create a Discount Voucher?",
            answer: (
                <div>
                    <p>If you would like to offer a Discount Voucher, follow these steps:</p>
                    <ol>
                        <li>Click on the left-hand menu called "Discount Voucher".</li>
                        <li>Click the "Add Voucher +" button.</li>
                        <li>
                            Enter the following details:
                            <ul>
                                <li>Title</li>
                                <li>Select the Business for which you want to create the Discount Voucher</li>
                                <li>Enter the Percent Discount (e.g., 5%)</li>
                                <li>Enter the Coupon Expiry Date</li>
                            </ul>
                        </li>
                        <li>Click on "Generate Coupon".</li>
                        <li>Click the "Add Voucher" button.</li>
                    </ol>
                    <p>All done! The Discount Voucher will appear at the top of your Business in the Mobile App.</p>
                </div>
            )
        }
    ];

    return (
        <Container
            maxWidth={false}
            disableGutters
            sx={classes.container} // Apply container styles
        >
            <Box id="FQA"
                sx={{
                    ...classes.headerBox,
                    backgroundImage: `url(${Frame})` // Set background image inline
                }}
            >
                <Box>
                    <Typography variant="h3" sx={classes.headerTextTitle}>
                        Frequently Asked Questions
                    </Typography>
                    <Typography variant="body1" sx={classes.headerText}>
                        Here are the answers to some of the most common questions our customers ask.
                    </Typography>
                </Box>
            </Box>

            <Grid
                container
                sx={{ display: "flex", justifyContent: "center", alignItems: "center", mt: 5 }}
            >
                <Grid item lg={10} md={10} sm={12} xs={11}>
                    {faqData.map((item, index) => (
                        <Accordion
                            key={`panel${index + 1}`}
                            expanded={expanded === `panel${index + 1}`}
                            onChange={handleChange(`panel${index + 1}`)}
                            sx={classes.fqaBox}
                        >
                            <AccordionSummary
                                expandIcon={getExpandIcon(`panel${index + 1}`)}
                                aria-controls={`panel${index + 1}bh-content`}
                                id={`panel${index + 1}bh-header`}
                            >
                                <Typography variant="h6" sx={classes.questionText}>
                                    {item.question}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography variant="body1" sx={classes.ansText}>
                                    {item.answer}
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </Grid>
            </Grid>
        </Container>
    );
}
